// Admin > Messages (Contact form submissions) tab.
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, Mail } from "lucide-react";
import { fmt } from "./_helpers";

export default function ContactsTab({ contacts, loading, markRead }) {
  if (contacts.length === 0) {
    return (
      <div className="space-y-3" data-testid="admin-contacts">
        <Card className="border-border shadow-none rounded-lg">
          <CardContent className="p-10 text-center text-sm text-muted-foreground">
            {loading ? "Loading…" : "No messages yet."}
          </CardContent>
        </Card>
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="admin-contacts">
      {contacts.map((c) => (
        <Card key={c.id} className="border-border shadow-none rounded-lg" data-testid={`contact-row-${c.id}`}>
          <CardContent className="p-5">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="font-medium">{c.name} <span className="font-normal text-muted-foreground">&lt;{c.email}&gt;</span></p>
                <p className="text-xs text-muted-foreground mt-0.5">{c.created_at ? fmt(c.created_at) : ""}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                {c.read_at ? (
                  <span className="text-xs text-muted-foreground">Read {fmt(c.read_at)}</span>
                ) : (
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => markRead(c.id)}
                    data-testid={`mark-read-${c.id}`}
                  >
                    <Check size={14} className="mr-1.5" /> Mark read
                  </Button>
                )}
                <a
                  href={`mailto:${c.email}?subject=Re:%20Your%20Dog%20Days`}
                  className="inline-flex items-center px-3 h-9 rounded-md border border-border text-sm hover:bg-muted"
                  data-testid={`reply-${c.id}`}
                >
                  <Mail size={14} className="mr-1.5" /> Reply
                </a>
              </div>
            </div>
            <p className="text-sm text-foreground/80 whitespace-pre-wrap mt-3 leading-relaxed">{c.message}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
